import React, { useEffect, useState } from 'react';
import {
  ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { AlertCircle, ArrowRight } from 'lucide-react';

export default function BeregnerKlientPipelineAnalysePanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/api/os/analyse-extra/beregner-pipeline', { credentials: 'include' })
      .then(r => r.ok ? r.json() : Promise.reject(r.statusText))
      .then(d => { setData(d); setLoading(false); })
      .catch(e => { setError(String(e)); setLoading(false); });
  }, []);

  if (loading) return <div style={{ color: '#9ca3af', padding: 24 }}>Henter pipeline-data...</div>;
  if (error) return <div style={{ color: '#ef4444', padding: 24, display: 'flex', alignItems: 'center', gap: 8 }}><AlertCircle size={16} /> {error}</div>;

  const { dage, total_sessioner, total_nye_klienter, konvertering_pct } = data;

  const konvFarve = konvertering_pct >= 5 ? '#22c55e' : konvertering_pct >= 2 ? '#f59e0b' : '#ef4444';

  return (
    <div style={{ width: '100%' }}>
      {/* KPI-tragt */}
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, marginBottom: 20 }}>
        <div style={{ flex: 1, minWidth: 120, background: 'rgba(59,130,246,0.1)', border: '1px solid rgba(59,130,246,0.3)', borderRadius: 8, padding: '10px 14px', textAlign: 'center' }}>
          <div style={{ color: '#3b82f6', fontSize: 22, fontWeight: 700 }}>{total_sessioner.toLocaleString('da-DK')}</div>
          <div style={{ color: '#9ca3af', fontSize: 12 }}>Beregner-sessioner</div>
        </div>
        <ArrowRight size={20} color="#6b7280" style={{ flexShrink: 0 }} />
        <div style={{ flex: 1, minWidth: 120, background: 'rgba(34,197,94,0.1)', border: '1px solid rgba(34,197,94,0.3)', borderRadius: 8, padding: '10px 14px', textAlign: 'center' }}>
          <div style={{ color: '#22c55e', fontSize: 22, fontWeight: 700 }}>{total_nye_klienter.toLocaleString('da-DK')}</div>
          <div style={{ color: '#9ca3af', fontSize: 12 }}>Nye klienter</div>
        </div>
        <ArrowRight size={20} color="#6b7280" style={{ flexShrink: 0 }} />
        <div style={{ flex: 1, minWidth: 120, background: `${konvFarve}18`, border: `1px solid ${konvFarve}55`, borderRadius: 8, padding: '10px 14px', textAlign: 'center' }}>
          <div style={{ color: konvFarve, fontSize: 22, fontWeight: 700 }}>{konvertering_pct}%</div>
          <div style={{ color: '#9ca3af', fontSize: 12 }}>Konverteringsrate</div>
        </div>
      </div>

      {/* Dual-axis chart */}
      <ResponsiveContainer width="100%" height={280}>
        <ComposedChart data={dage} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.08)" />
          <XAxis
            dataKey="dag"
            tick={{ fill: '#9ca3af', fontSize: 11 }}
            tickFormatter={v => v ? v.slice(5) : ''}
            interval={4}
          />
          <YAxis yAxisId="left" tick={{ fill: '#9ca3af', fontSize: 11 }} label={{ value: 'Sessioner', angle: -90, position: 'insideLeft', fill: '#9ca3af', fontSize: 11, dx: -8 }} />
          <YAxis yAxisId="right" orientation="right" tick={{ fill: '#9ca3af', fontSize: 11 }} label={{ value: 'Klienter', angle: 90, position: 'insideRight', fill: '#9ca3af', fontSize: 11, dx: 8 }} />
          <Tooltip
            contentStyle={{ background: '#1e2235', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, color: '#fff' }}
          />
          <Legend wrapperStyle={{ color: '#9ca3af', fontSize: 12 }} />
          <Bar yAxisId="left" dataKey="sessioner" name="Sessioner" fill="#3b82f6" opacity={0.75} radius={[2, 2, 0, 0]} />
          <Line yAxisId="right" type="monotone" dataKey="nye_klienter" name="Nye klienter" stroke="#22c55e" strokeWidth={2} dot={{ r: 3, fill: '#22c55e' }} />
        </ComposedChart>
      </ResponsiveContainer>

      {/* Note */}
      <div style={{ marginTop: 12, color: '#6b7280', fontSize: 12, fontStyle: 'italic' }}>
        Datakorrelation er indikativ — ikke kausal
      </div>
    </div>
  );
}
